import { http } from 'interfaces'
import { type Organization } from 'components'

export interface OrgFilterResults {
  data: Organization[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}

export async function orgListFilter (params: any): Promise<OrgFilterResults> {
  return await http.get('/api/v1/organizations/', {
    params: { ...params }
  }).then(value => value.data)
    .catch(reason => { return { data: [], page_number: 0, page_size: 0, total_items: 0, total_pages: 0 } })
}
